import { Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import Groups from "./Groups";
import Account from "../../Pages/account";
import Machines from "./Machines";
import Subscriptions from "../../Pages/subscriptions";

import "./styles.less";
import UserContext from "../../themeContext/UserContext";
import { useContext } from "react";

const { TabPane } = Tabs;

interface Props {
  activeTab: "account" | "subscription" | "machines" | "groups";
}

const SettingsMain: React.FC<Props> = ({ activeTab }) => {
  const { userInfo } = useContext(UserContext);
  const navigate = useNavigate();
  const onChange = (key: string) => {
    navigate("/dashboard/" + key);
  };

  return (
    <Tabs defaultActiveKey="account" activeKey={activeTab} className="settings-tab" onChange={onChange}>
      <TabPane tab="Account" key="account">
        <Account />
      </TabPane>
      <TabPane tab="Subscription" key="subscription">
        <Subscriptions />
      </TabPane>
      <TabPane tab="Machines" key="machines">
        <Machines />
      </TabPane>
      {userInfo.accountType == "free" ? (
        <></>
      ) : (
        <TabPane tab="Groups" key="groups">
          <Groups />
        </TabPane>
      )}
    </Tabs>
  );
};

export default SettingsMain;
